if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.rxcActivatorBtn = this.querySelector("[name='rxc-activator']");
        if (!this.form || !this.submitButton) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.toggleSubmitButton(true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              // if (!soldOutMessage) return;
              this.toggleSubmitButton(true);
              // this.submitButtonText.classList.add('hidden');
              // soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.rxcActivatorBtn) {
              this.rxcActivatorBtn.removeAttribute('disabled');
              this.rxcActivatorBtn.removeAttribute('aria-disabled');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error){
              // debugger;
              this.toggleSubmitButton(false);
            } else {
              this.error = false;
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          // hide error message after 5 seconds
          setTimeout(() => {
            this.errorMessageWrapper.setAttribute('hidden', '');
          }, 5000);

          // also hide the error message when the user clicks on close icon
          const closeButton = this.errorMessageWrapper.querySelector('button[title="Close"]');
          closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.errorMessageWrapper.setAttribute('hidden', '');
          });

          // also disable the submit button
          this.toggleSubmitButton(true);
          // and the sticky add to cart button
          const stickyAddToCartButton = document.querySelector('atc-ref-btn button');
          if (stickyAddToCartButton)
            stickyAddToCartButton.setAttribute('disabled', 'disabled');
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (this.submitButton) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.setAttribute('aria-disabled', 'true');
            if (text) this.submitButtonText.textContent = text;
            if (this.rxcActivatorBtn) {
              this.rxcActivatorBtn.setAttribute('disabled', 'disabled');
              this.rxcActivatorBtn.setAttribute('aria-disabled', 'true');
            }
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
